import { createApp } from 'vue'
import PersonalDonationStep2a from './PersonalDonationStep2a'

const el = '.kb-component--personal-donation-step2-a'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((PersonalDonationStep2aDOM) => {
            const component = createApp(PersonalDonationStep2a).use(Store)
            component.mount(PersonalDonationStep2aDOM)
        })
    }
}
